import RoutesList from "./routes/RoutesList";
import MaintenancePage from "./components/maintenance/MaintenancePage";
import { isMaintenanceMode } from "./config/maintenance";
import { AuthProvider } from "./features/auth/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./i18n";

function App() {
  if (isMaintenanceMode()) {
    return <MaintenancePage />;
  }
  return (
    <AuthProvider>
      <RoutesList />
    </AuthProvider>
  );
}

export default App;
